import { useNavigate } from "react-router-dom";
import { ArrowLeftIcon } from "lucide-react";

import { RoutingItem } from "@/layouts/AppLayout/AppSidebar/AppSidebarRoutingItem";

const RETURN_URL_KEY = "settings:returnTo";
const DEFAULT_RETURN_URL = "/app/triage";

/** The way back out of settings, drawn as the rows under it are - its icon alone, centred, once the sidebar is minimized. */
const BACK_TO_APP_ITEM = {
  key: "back-to-app",
  name: "Back to app",
  icon: <ArrowLeftIcon size="1em" />,
};

export function SettingsSidebarHeader() {
  const navigate = useNavigate();

  const handleBack = () => {
    const returnTo =
      sessionStorage.getItem(RETURN_URL_KEY) ?? DEFAULT_RETURN_URL;
    sessionStorage.removeItem(RETURN_URL_KEY);
    navigate(returnTo);
  };

  return (
    <div className="w-full h-12 flex items-center overflow-hidden relative z-1">
      <RoutingItem
        item={BACK_TO_APP_ITEM}
        isActive={false}
        onClick={handleBack}
      />
    </div>
  );
}

export { RETURN_URL_KEY as SETTINGS_RETURN_URL_KEY };
